import request from '@/router/axios';

export const getAress = (params) => {
  return request({
    url: '/api/blade-system/region/lazy-tree',
    method: 'get',
    params: {
      parentCode: params
    }
  })
}
